import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "./components/Layout";

import Home from "./pages/Home";
import OurGenesis from "./pages/OurGenesis";
import Visionaries from "./pages/Visionaries";
import WhyCapitol from "./pages/WhyCapitol";
import OurFaculties from "./pages/OurFaculties";
import Infrastructure from "./pages/Infrastructure";
import Contact from "./pages/Contact";
import Careers from "./pages/Careers";
import Admissions from "./pages/Admissions";
import Rules from "./pages/Rules";
import Schedule from "./pages/Schedule";
import Uniform from "./pages/Uniform";
import CodeOfConduct from "./pages/CodeOfConduct";
import Curriculum from "./pages/Curriculum";
import AssessmentPlan from "./pages/AssessmentPlan";
import GalleryPreview from "./components/GalleryPreview";


function App() {
  return (
    <BrowserRouter>
      <Routes>

        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/our-genesis" element={<Layout><OurGenesis /></Layout>} />
        <Route path="/visionaries" element={<Layout><Visionaries /></Layout>} />
        <Route path="/why-capitol" element={<Layout><WhyCapitol /></Layout>} />
        <Route path="/faculties" element={<Layout><OurFaculties /></Layout>} />
        <Route path="/infrastructure"element={<Layout><Infrastructure /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>}/>
        <Route path="/careers" element={<Layout><Careers /></Layout>}/>
        <Route path="/gallery" element={<Layout><GalleryPreview /></Layout>}/>
        <Route path="/admissions" element={<Layout><Admissions /></Layout>}/>
        <Route path="/rules" element={<Layout><Rules /></Layout>} />
        <Route path="/schedule" element={<Layout><Schedule /></Layout>} />
        <Route path="/uniform" element={<Layout><Uniform /></Layout>} />
        <Route path="/code-of-conduct" element={<Layout><CodeOfConduct /></Layout>}/>
        <Route path="/curriculum" element={<Layout><Curriculum /></Layout> }/>
        <Route path="/assessment-plan"element={<Layout><AssessmentPlan /></Layout>}/>

      </Routes>
    </BrowserRouter>
  );
}

export default App;